/*
  «Ver más reseñas»: enseña la siguiente tanda.

  POR QUE ESTE ARCHIVO SE LLAMA `-2` Y NO SUSTITUYE AL ANTERIOR, 28/10/2026:
  al reescribirlo, el CDN siguio sirviendo el minificado viejo de
  `av-resenas-todas.js` durante mas de dos minutos, tambien pidiendolo con
  otra query. Y el guion viejo con el marcado nuevo deja el boton MUERTO: no
  hay ningun `li` con la clase `--oculto` que descubrir, asi que al pulsar no
  pasa nada. Con la tienda recibiendo trafico de pago no se podia dejar eso al
  azar de una cache, y un nombre nuevo no puede estar cacheado. El viejo se
  queda en el tema, sin que nadie lo cargue.

  DE DONDE SALEN LAS RESEÑAS QUE AUN NO SE VEN, cambiado el 28/10/2026: las
  cinco primeras son `<li>` de verdad y las 45 restantes esperan dentro de un
  `<template class="av-todas__resto">`, que es un fragmento inerte y no cuenta
  como DOM. Antes estaban las 50 pintadas y 45 ocultas por CSS: 830 nodos y
  96 KB en una sola seccion, el 24% de los nodos de la ficha.

  SIGUE SIN PEDIR NADA AL SERVIDOR. Los `li` se MUEVEN del fragmento a la
  lista, no se clonan, asi que el propio `<template>` se vacia solo y hace de
  cola: lo que queda dentro es exactamente lo que falta por enseñar. Sin
  latencia y sin nada que pueda fallar por red a mitad de una compra.

  SE ATIENDEN LOS DOS CASOS a proposito. Si alguna vez vuelve a haber `li`
  ocultos en la lista -por un repintado del editor, o porque alguien
  reponga el marcado de antes-, se descubren esos primero y el
  `<template>` se usa solo cuando no quedan. Asi el boton nunca se queda sin
  efecto.

  El oyente cuelga de `document` y no del boton: el editor de temas repinta la
  seccion al tocar sus ajustes, y unos oyentes puestos sobre el boton moririan
  con el primer repintado. Ver 'scripts-en-bloques-repintados'.
*/
(function () {
  if (window.avResenasTodas) return;
  window.avResenasTodas = true;

  document.addEventListener('click', function (e) {
    var boton = e.target.closest ? e.target.closest('.av-todas__mas') : null;
    if (!boton) return;

    var caja = boton.closest('.av-todas');
    var lista = caja && caja.querySelector('.av-todas__lista');
    if (!lista) return;

    var tanda = parseInt(lista.dataset.tanda, 10) || 5;
    var resto = caja.querySelector('.av-todas__resto');
    var primera = null;
    var i;

    /* Caso heredado: las que ya estan en la lista pero tapadas por CSS. */
    var ocultas = lista.querySelectorAll('.av-todas__item--oculto');
    for (i = 0; i < tanda && i < ocultas.length; i++) {
      ocultas[i].classList.remove('av-todas__item--oculto');
      if (!primera) primera = ocultas[i];
    }

    /* Caso normal: traerlas del `<template>`. `firstElementChild` salta los
       nodos de texto que deja el sangrado de Liquid, y `appendChild` las
       SACA del fragmento. */
    if (!primera && resto && resto.content) {
      for (i = 0; i < tanda && resto.content.firstElementChild; i++) {
        var li = resto.content.firstElementChild;
        lista.appendChild(li);
        if (!primera) primera = li;
      }
    }

    /* Si ya no queda ninguna, el boton sobra: dejarlo puesto sin efecto es
       peor que no tenerlo. Hay que mirar los dos sitios. */
    var quedan = lista.querySelector('.av-todas__item--oculto') ||
      (resto && resto.content && resto.content.firstElementChild);
    if (!quedan) boton.remove();

    /* El foco va a la primera recien aparecida. Sin esto, quien navegue con
       teclado o lector de pantalla se queda donde estaba y no se entera de
       que han salido cinco reseñas nuevas. */
    if (primera) {
      primera.setAttribute('tabindex', '-1');
      primera.focus({ preventScroll: true });
    }
  });
})();
